(function($, window, undefined) {
    var $table = $(),
        $stickyHead;

    var methods = {
        init: function(options) {
            var self = this;

            $table
                .find('th')
                .each(function(i, el) {
                    $(el).css({
                        width: $(el).width()
                    });
                })
                .end()
                .css('table-layout', 'fixed');

            var $thead = $table.find('thead');
            var $theadCopy = $thead.clone();

            // Create wrapper
            var $stickyWrap = $('<div />', {
                class: 'sticky-table'
            });

            $table.wrap($stickyWrap);

            // Create new sticky table head
            var tableClasses = $table.attr('class');
            $stickyHead = $('<table />', {
                class: tableClasses + ' sticky-table__head',
                css: {
                    width: $table.width()
                }
            });

            // Insert
            $('.site-canvas').prepend($stickyHead);

            // Sticky header <table> gets all content from <thead>
            $stickyHead.append($theadCopy);

            // Move original thead out of view (still required to calculate th widths when columns change)
            $table.css({
                marginTop: -$thead.outerHeight()
            });

            $(document).ready(function() {
                methods.setColumnWidths(self);
            });

            $(window).on('resize', function() {
                methods.setColumnWidths(self);
            });

            window.addEventListener('orientationchange', function() {
                setTimeout(function() {
                    methods.setColumnWidths(self);
                }, 300);
            });
        },

        setColumnWidths: function() {
            if ($stickyHead) {
                $stickyHead.css('width', $table.width());

                var $stickyCols = $stickyHead.find('th');

                $table
                    .css('table-layout', 'auto')
                    .find('th')
                    .css({
                        width: 'auto'
                    })
                    .each(function(i, el) {
                        // Find organic width
                        var w = $(el).width();

                        // Set as its fixed width
                        $(el).css({
                            width: w
                        });

                        // Apply the same width to the sticky header <th>
                        $stickyCols.eq(i).css({
                            width: w
                        });
                    })
                    .end()
                    .css('table-layout', 'fixed');
            }
        }
    };

    $.fn.stickyTableLandfinder = function(methodOrOptions) {
        $table = this; // "this" is the jQuery object the plugin was invoked on

        if (methods[methodOrOptions]) {
            let callCall;
            if (Array.prototype.slice) {
                callCall = Array.prototype.slice.call(arguments, 1);
            }
            return methods[methodOrOptions].apply(this, callCall);
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            // Default to "init"
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist on jQuery.stickyTableLandfinder');
        }
    };
})(jQuery, window);
